/**
 * Player functionality
 */

module.exports = function(player) {
    'use strict';

    var icon_play = 'fa-play';
    var icon_stop = 'fa-stop';
    var button = '.js-play';
    var canPlay = false;

    // On click use virtual dom and play
    $(document).off('click', button);
    $(document).on('click', button, function(){

        // Default stop class
        icon_stop = $(this).data('toggle') || icon_stop;
        player.datafileName = $(this).data('src').split('\\').pop().split('/').pop();
        player.sourceName = player.src.split('\\').pop().split('/').pop();

        // If we trying to play nex track - force to play it
        if (decodeURIComponent(player.datafileName) !== decodeURIComponent(player.sourceName)) {
            player.src = $(this).data('src');
            player.volume = 1;

            startPlayer($(this));
        }
        else {
            // If already playing stop and change icons
            if (!player.paused) {
                stopPlayer();
            } else {
                if (false === canPlay) {
                    $('body').pgNotification({message: window.app.trans.audio.error_message, type: 'danger'}).show();
                    stopPlayer();
                } else {
                    startPlayer($(this));
                }
            }
        }
    });

    // On ended change icon
    player.addEventListener("ended", function () {
        stopPlayer();
    });

    // On error - display message
    player.addEventListener('error', function (data) {
        $('body').pgNotification({message: window.app.trans.audio.error_message, type: 'danger'}).show();
        canPlay = false;
        stopPlayer();
    });

    // Can we play the audio?
    player.addEventListener('oncanplaythrough', function () {
        canPlay = true;
    });
    player.addEventListener('canplay', function () {
        canPlay = true;
    });

    function startPlayer(target) {
        stopPlayer();
        target
            .toggleClass(icon_play, false)
            .toggleClass(icon_stop, true)
        ;
        player.play();
    }

    function stopPlayer() {
        $(button)
            .toggleClass(icon_play, true)
            .toggleClass(icon_stop, false)
        ;
        player.pause();
        player.currentTime = 0;
    }

    return player;
};
